import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { sitesAPI } from '../utils/api';

export const useSiteStore = create(
  persist(
    (set, get) => ({
      sites: [],
      selectedSite: null,
      isLoading: false,
      error: null,

      fetchSites: async () => {
        set({ isLoading: true });
        try {
          const response = await sitesAPI.getSites();
          const sites = response.data;
          set({ sites, isLoading: false });
          
          // Auto-select first site if none selected
          if (!get().selectedSite && sites.length > 0) {
            set({ selectedSite: sites[0] });
          }
        } catch (error) {
          set({ 
            error: error.response?.data?.error || 'Failed to fetch sites',
            isLoading: false 
          });
        }
      },

      setSelectedSite: (site) => {
        set({ selectedSite: site });
      },

      updateSite: (siteId, data) => {
        set((state) => ({
          sites: state.sites.map(s => 
            s.id === siteId ? { ...s, ...data } : s
          ),
          selectedSite: state.selectedSite?.id === siteId 
            ? { ...state.selectedSite, ...data }
            : state.selectedSite
        }));
      },
    }),
    {
      name: 'site-storage',
      partialize: (state) => ({
        selectedSite: state.selectedSite,
      }),
    }
  )
);
